import {useEffect, useMemo, useState} from "react";
import {useRestClient} from "../client/SpmRestClient";
import {Form, Spinner} from "react-bootstrap";
import {RegionView} from "../types/Region";
import {StringUtil} from "zavadil-ts-common";
import {useAlerts} from "../utils/UserAlerts";

export type SelectRegionTypeProps = {
	regionId?: number | null;
	onChange(regionId?: number | null): any;
}

type RegionOption = RegionView & {
	children: Array<RegionView>;
}

export default function SelectRegion({regionId, onChange}: SelectRegionTypeProps) {
	const restClient = useRestClient();
	const userAlerts = useAlerts();
	const [regions, setRegions] = useState<Array<RegionView>>();

	useEffect(
		() => {
			restClient.regions.all()
				.then(setRegions)
				.catch((e) => userAlerts.err(e));
		},
		[]
	);

	const options: Array<RegionOption> | null = useMemo(
		() => {
			if (!regions) return null;
			const result: Array<RegionOption> = [];
			regions
				.filter((r) => r.parentId === null)
				.forEach((r) => result.push({...r, children: []}));
			regions
				.filter((r) => r.parentId !== null)
				.forEach(
					(r) => {
						const parent = result.find((opt) => opt.id === r.parentId);
						if (parent) parent.children.push(r);
					}
				);
			return result;
		},
		[regions]
	);

	if (!options) return <Spinner/>;

	return <Form.Select
		value={regionId ? String(regionId) : ''}
		onChange={(e) => onChange(StringUtil.isBlank(e.target.value) ? null : Number(e.target.value))}
	>
		<option key={""} value={""}></option>
		{
			options.map(
				(option) => <optgroup key={option.id} label={option.name}>
					{
						option.children.map(
							(child) => <option key={child.id} value={String(child.id)}>
								{child.name}
							</option>
						)
					}
				</optgroup>
			)
		}
	</Form.Select>
}
